(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire637e"];
var parcelRegister = parcelRequire.register;
parcelRegister("9Q2vk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $01d935514d7c1186$export$2e2bcd8739ae039; });

var $jbXyA = parcelRequire("jbXyA");

var $J7ygF = parcelRequire("J7ygF");

var $hvJJn = parcelRequire("hvJJn");

var $1vaY4 = parcelRequire("1vaY4");

var $6MRuB = parcelRequire("6MRuB");
var $01d935514d7c1186$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function CollectionFilter(param) {
        var el = param.el, isLargeQuery = param.isLargeQuery;
        (0, $J7ygF._)(this, CollectionFilter);
        this.form = el;
        this.isLargeQuery = isLargeQuery;
        // actual filtering
        this.checkboxes = Array.from(this.form.querySelectorAll(".filter-checkbox"));
        this.containerElString = this.form.getAttribute("data-container-el");
        this.productList = document.getElementById(this.containerElString);
        this.searchParamsInitial = window.location.search.slice(1);
        this.searchParamsPrev = window.location.search.slice(1);
        this.resetButtons = Array.from(this.form.querySelectorAll(".reset-button"));
        this.filterType = this.form.getAttribute("data-type");
        this.sectionToRender = this.filterType === "collection" ? "main-collection" : "main-search";
        this.resetFilters = this.form.querySelectorAll("[data-filter-reset]");
        this.init();
    }
    (0, $hvJJn._)(CollectionFilter, [
        {
            key: "init",
            value: function init() {
                var _this = this;
                // filter checkboxes
                this.checkboxes.forEach(function(checkbox) {
                    checkbox.addEventListener("change", function() {
                        var params = _this.getSearchParams();
                        _this.renderPage(params, true);
                    });
                });
                this.resetFilters.forEach(function(resetFilter) {
                    var _this1 = _this;
                    resetFilter.addEventListener("click", function() {
                        var _ref = (0, $jbXyA._)(function(e) {
                            var paramName, params;
                            return (0, $1vaY4.__generator)(this, function(_state) {
                                e.preventDefault();
                                paramName = resetFilter.dataset.filterReset;
                                params = _this1.getSearchParams({
                                    paramToRemove: paramName
                                });
                                _this1.renderPage(params, true);
                                return [
                                    2
                                ];
                            });
                        });
                        return function(e) {
                            return _ref.apply(this, arguments);
                        };
                    }());
                });
                this.resetButtons.forEach(function(button) {
                    var _this1 = _this;
                    button.addEventListener("click", function() {
                        var _ref = (0, $jbXyA._)(function(e) {
                            return (0, $1vaY4.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        e.preventDefault();
                                        return [
                                            4,
                                            _this1.renderPage(false, true, true)
                                        ];
                                    case 1:
                                        _state.sent();
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function(e) {
                            return _ref.apply(this, arguments);
                        };
                    }());
                });
                window.addEventListener("popstate", this.onHistoryChange.bind(this));
            }
        },
        {
            key: "renderPage",
            value: function renderPage(searchParams) {
                var updateFilters = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, updateUrl = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
                var _this = this;
                return (0, $jbXyA._)(function() {
                    var url;
                    return (0, $1vaY4.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (_this.form.classList.contains("is-mobile")) (0, $6MRuB.emitter).emit("filters:close");
                                // set previous search params
                                _this.searchParamsPrev = searchParams;
                                _this.productList.style.opacity = ".3";
                                if (updateUrl) _this.updateUrl(searchParams);
                                // check if search params is empty
                                if (!searchParams || searchParams.filterParams.length === 0) _this.form.classList.add("hide-reset");
                                else _this.form.classList.remove("hide-reset");
                                // update form filters
                                if (updateFilters) {
                                    _this.checkboxes.forEach(function(checkbox) {
                                        checkbox.classList.add("yup");
                                        // replace spaces with +
                                        var paramChecker = checkbox.dataset.paramChecker.replace(/\s+/g, "+");
                                        if ((searchParams === null || searchParams === void 0 ? void 0 : searchParams.filterParams) && searchParams.filterParams.includes(paramChecker)) {
                                            checkbox.checked = true;
                                            // hide nearest li
                                            checkbox.closest("li").classList.add("hidden");
                                            console.log(checkbox.closest("li"));
                                            // get nearest '.filter-group'
                                            var filterGroup = checkbox.closest(".filter-group");
                                            // get '.active-filter-item' inside filter group
                                            var activeFilterItem = filterGroup.querySelector(".active-filter-item p");
                                            var resetFilter = filterGroup.querySelector(".reset-filter");
                                            if (activeFilterItem) activeFilterItem.textContent = checkbox.labels[0].textContent;
                                            if (resetFilter) resetFilter.classList.remove("hidden");
                                        } else {
                                            checkbox.checked = false;
                                            checkbox.closest("li").classList.remove("hidden");
                                        }
                                    });
                                    // for each reset button, check if it's active
                                    _this.resetFilters.forEach(function(resetFilter) {
                                        var paramName = resetFilter.dataset.filterReset;
                                        if ((searchParams === null || searchParams === void 0 ? void 0 : searchParams.filterParams) && searchParams.filterParams.includes(paramName)) resetFilter.classList.remove("hidden");
                                        else {
                                            resetFilter.classList.add("hidden");
                                            var filterGroup = resetFilter.closest(".filter-group");
                                            var activeFilterItem = filterGroup.querySelector(".active-filter-item p");
                                            if (activeFilterItem) activeFilterItem.textContent = "All";
                                        }
                                    });
                                }
                                // get filter url
                                url = "".concat(window.location.pathname, "?").concat(searchParams.q ? "q=".concat(searchParams.q, "&type=product&") : "", "section_id=").concat(_this.sectionToRender).concat(searchParams.filterParams ? "&".concat(searchParams.filterParams) : "");
                                // fetch new products list via section rendering api
                                return [
                                    4,
                                    fetch(url).then(function(response) {
                                        return response.text();
                                    }).then(function(html) {
                                        var resultsMarkup = new DOMParser().parseFromString(html, "text/html");
                                        var productHTML = resultsMarkup.querySelector("#product-list").innerHTML;
                                        // update products list
                                        _this.productList.innerHTML = productHTML;
                                        _this.productList.style.opacity = "1";
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getSearchParams",
            value: function getSearchParams() {
                var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_paramToRemove = _ref.paramToRemove, paramToRemove = _ref_paramToRemove === void 0 ? null : _ref_paramToRemove;
                // check if there is a 'q' search param in url
                var url = new URL(window.location);
                var searchParams = url.searchParams;
                var q = searchParams.get("q");
                var formData = new FormData(this.form);
                // If paramToRemove is provided, remove it from formData
                if (paramToRemove) formData.delete(paramToRemove);
                return {
                    q: q,
                    filterParams: new URLSearchParams(formData).toString()
                };
            }
        },
        {
            key: "updateUrl",
            value: function updateUrl(searchParams) {
                if (searchParams) history.pushState({
                    searchParams: searchParams
                }, "", "".concat(window.location.pathname, "?").concat(searchParams.q ? "q=".concat(searchParams.q, "&type=product").concat(searchParams.filterParams ? "&" : "") : "").concat(searchParams.filterParams));
                else history.pushState({}, "", "".concat(window.location.pathname));
            }
        },
        {
            key: "onHistoryChange",
            value: function onHistoryChange(e) {
                var searchParams = e.state ? e.state.searchParams : this.searchParamsInitial;
                if (searchParams === this.searchParamsPrev) return;
                this.renderPage(searchParams, true, false);
            }
        }
    ]);
    return CollectionFilter;
}();

});

})();
//# sourceMappingURL=CollectionFilter.3fa45256.js.map
